import { render, staticRenderFns } from "./login.vue?vue&type=template&id=12ddd2de&scoped=true&"
import script from "./login.vue?vue&type=script&lang=js&"
export * from "./login.vue?vue&type=script&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=12ddd2de&scoped=true&lang=stylus&"
import style1 from "./login.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ddd2de",
  null
  
)

export default component.exports